// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/themes/_theme_worklife.scss
// module id = 606
// module chunks = 1 2